<app-select-searching-input [leftIconSvg]='"patient"' [leftIconClass]="'text-primary'" [noOptionText]="'-- Todos --'"
    [defaultValue]="'0'" [name]="this.name" [nameSearching]="this.nameSearching" [form]="this.form"
    [label]="'Filtro por paciente'" [elements]="this.patients" [placeholderNoValue]="'Sin resultados'"
    [calculateName]="this.calculatePatientDNI" [placeholderSearching]="'Buscar DNI de paciente...'">
</app-select-searching-input>
